import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ContactChoice, GroupChoice, PreferenceInput, RelationshipCatalogue, RelationshipDetail, RelationshipListing, RelationshipSave } from './relationship.models';

@Injectable({ providedIn: 'root' })
export class ContactRelationshipService {
  private readonly endpoint = '/api/contact_relationships.php';
  constructor(private readonly http: HttpClient) {}
  private get<T>(action: string, query: Record<string, string> = {}): Observable<T> {
    return this.http.get<T>(this.endpoint, { params: new HttpParams({ fromObject: { action, ...query } }) });
  }
  catalogue(): Observable<RelationshipCatalogue> { return this.get('catalogue'); }
  list(query: Record<string, string>): Observable<RelationshipListing> { return this.get('list', query); }
  detail(uuid: string): Observable<RelationshipDetail> { return this.get('detail', { uuid }); }
  contacts(type: string, role: string, q: string, contact = ''): Observable<{ data: ContactChoice[] }> {
    return this.get('contacts', { type, role, q, ...(contact ? { contact } : {}) });
  }
  groups(type: string, customer: string, kind: string, q: string): Observable<{ data: GroupChoice[] }> {
    return this.get('groups', { type, customer, kind, q });
  }
  save(body: RelationshipSave, uuid?: string): Observable<RelationshipDetail> {
    return uuid ? this.http.put<RelationshipDetail>(this.endpoint, body, { params: { action: 'update', uuid } })
      : this.http.post<RelationshipDetail>(this.endpoint, body, { params: { action: 'create' } });
  }
  remove(uuid: string, expected_version: number): Observable<{ ok: boolean }> {
    return this.http.delete<{ ok: boolean }>(this.endpoint, { params: { action: 'delete', uuid }, body: { expected_version } });
  }
  savePreference(uuid: string, body: PreferenceInput & { expected_version?: number }, preference_uuid?: string): Observable<RelationshipDetail> {
    return preference_uuid
      ? this.http.put<RelationshipDetail>(this.endpoint, body, { params: { action: 'preference_update', uuid, preference_uuid } })
      : this.http.post<RelationshipDetail>(this.endpoint, body, { params: { action: 'preference_create', uuid } });
  }
  removePreference(uuid: string, preference_uuid: string, expected_version: number): Observable<RelationshipDetail> {
    return this.http.delete<RelationshipDetail>(this.endpoint, { params: { action: 'preference_delete', uuid, preference_uuid }, body: { expected_version } });
  }
}
